import store from '@/store'

export default [
  {
    path: '/cradit-transfers',
    name: 'cradit-transfer',
    meta: { requiresAuth: true },
    component: () => import('@/pages/credit-transfer/index.vue')
  },
  {
    path: '/cradit-transfer/create',
    name: 'credit-transfer-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/credit-transfer/create.vue')
  },
  {
    path: '/cradit-transfer/form-student',
    name: 'form-student-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/credit-transfer/form-student.vue')
  },
]
